module.exports = __webpack_public_path__ + "static/media/no-file.bd45e664.png";